function MenuRodape() {
    return (
      <div className="MenuRodape">
        <footer className="MenuRodape-footer">
          <h3>Navegação:</h3>
            <ul className="mapaFooter">
              <li><a href="/">Página Inicial</a></li>
              <li><a href="/catalogo">Produtos</a></li>
              <li><a href="/contato">Contato</a></li>
            </ul>
        </footer>
      </div>
    );
  }
  
  export default MenuRodape;
  